import strings from '../../Localization/Localization';

import {
  index,
  getFromId,
  getSafeguardFromId,
  getSafeguardPriceFromId,
  editFromId,
  editSafeguardFromId,
  newItem
} from '../../API/PhonePackages';
import {
  form,
  safeguardForm,
  safeguardPriceForm,
  newForm
} from '../Form/phonePackages';
import { form as searchForm } from '../Form/Search/phonePackages';

import { phonePackage as routes } from '../Route/routes';

export const conf = {
  index: {
    pageTitle: strings.common.homepage.phonePackage,

    id: "phonePackage",
    api: index,
    onClickItem: {
      redirect: true,
      path: (id) => routes.routes.show.createPath(id)
    },

    searchForm: searchForm,
    computeSearch: (search) => {
      let result = {};
      if(search.name) {
        result["name"] = search.name;
      }
      return result;
    },

    availableItemDisplay:['line'],
    itemDisplay: {
      line: {
        label: (item) => `${item["name"]}`
      },
    },

    sizing: {
      numberColumn: 2,
      formSizeMd: 12
    },

    buttons: (item) => []
  },
  show: {
    pageTitle: strings.common.homepage.phonePackage,
    pageTitleReturnPath: () => routes.routes.index.createPath(),
    breadcrumbIdentifier: "name",

    apiGet: getFromId,

    extendedHeader: false,

    tabs: {
      main: {
        title: strings.phonePackage.tab.main,
        type: 'form',
        form: form,

        onUpdateItem: (data) => {},
        onSubmit: (entity) => {},
        postEdit: {
          type: 'tab',
          tabId: 'main'
        },

        apiGet: getFromId,
        apiEdit: editFromId,

        role: ['ROLE_CDR'],
        editable: ['ROLE_CDR_PHONE_PACKAGE_EDIT']
      },
      safeguard: {
        title: strings.phonePackage.tab.safeguard,
        type: 'form',
        form: safeguardForm,

        apiGet: getSafeguardFromId,
        apiEdit: editSafeguardFromId,

        role: ['ROLE_CDR'],
        editable: ['ROLE_CDR_PHONE_PACKAGE_EDIT']
      },
      safeguardPrice: {
        title: strings.phonePackage.tab.safeguardPrice,
        type: 'form',
        form: safeguardPriceForm,
        disabled: true,

        apiGet: getSafeguardPriceFromId,

        auth: ['ROLE_CDR'],
        editable: false
      },
    }
  },
  new: {
    pageTitle: strings.phonePackage.new.title,

    api: newItem,
    empty: {},
    form: newForm,
    onSubmit: (phonePackage) => {},
    postNew: {
      type: 'path',
      path: (id) => routes.routes.show.createPath(id)
    }
  }
}
